/**
 * Liquid Cooling CDU per-instance editor — placeholders + option lists for the 6 CDU fields (#996 Phase 3).
 * Mirrors coolingSystemRequirementsUi. Placeholder text reuses the labels/placeholders
 * already shown in the LiquidCooling step.
 */

/** Rack vs Row CDU placement (lcCduType dropdown). */
export const LIQUID_COOLING_CDU_RACK_OR_ROW_OPTIONS = ['Rack', 'Row'] as const;

export const LIQUID_COOLING_CDU_PLACEHOLDERS = {
  cduType: 'Select CDU placement: Rack or Row',
  cduRedundancy: 'Select N, N+1, or 2N',
  leakDetectionApproach: 'Enter text',
  description: 'Describe the liquid cooling scope',
} as const;
